import { Link } from "react-router-dom";
import { rankArticles } from "@/mocks/articles";
import { categories } from "@/mocks/site";

export default function HeroSection() {
  const top = rankArticles[0];
  return (
    <section className="relative overflow-hidden bg-background-50 pt-24 md:pt-28">
      {/* 装饰层 */}
      <div
        aria-hidden
        className="pointer-events-none absolute -right-24 -top-16 select-none font-heading text-[20rem] font-black leading-none text-primary-50 md:text-[28rem]"
      >
        料
      </div>
      <div
        aria-hidden
        className="pointer-events-none absolute left-1/3 top-0 h-72 w-72 rounded-full bg-accent-100/50 blur-3xl"
      />

      <div className="relative mx-auto grid max-w-7xl gap-12 px-4 pb-14 md:px-6 md:pb-20 lg:grid-cols-12 lg:gap-10">
        {/* 左：文案 */}
        <div className="lg:col-span-7">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1.5 text-xs font-semibold text-primary-700">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary-400 opacity-75" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-500" />
            </span>
            编辑团队 · 每日甄选更新
          </span>

          <h1 className="mt-6 font-heading text-4xl font-black leading-tight tracking-tight text-foreground-950 md:text-6xl">
            好料那么多，
            <br />
            <span className="text-primary-600">看料替你挑</span>
          </h1>
          <p className="mt-6 max-w-xl text-base leading-8 text-foreground-700 md:text-lg md:leading-9">
            看料聚焦<span className="font-semibold text-primary-700">看料精选</span>与
            <span className="font-semibold text-primary-700">热门推荐</span>，编辑团队每日从
            数字工作、阅读新知、生活灵感与认知成长中，筛出真正值得看的好料。
            不用自己慢慢翻，点开就能看到当下最值得关注的。
          </p>

          <div className="mt-8 flex flex-wrap items-center gap-3">
            <a
              href="#picks"
              className="inline-flex h-11 items-center gap-2 rounded-md bg-primary-500 px-6 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
            >
              看今日精选好料
              <i className="ri-arrow-down-line" />
            </a>
            <Link
              to="/rank"
              className="inline-flex h-11 items-center gap-2 rounded-md bg-background-200/70 px-6 text-sm font-semibold text-foreground-800 transition-colors hover:bg-accent-500 hover:text-background-50 whitespace-nowrap"
            >
              <i className="ri-fire-fill text-accent-500" />
              热门编辑榜单
            </Link>
          </div>

          {/* 分类快捷入口 */}
          <div className="mt-9 flex flex-wrap items-center gap-2.5">
            <span className="text-xs font-semibold tracking-wide text-foreground-500">
              按兴趣浏览
            </span>
            {categories.map((c) => (
              <Link
                key={c.slug}
                to={`/category/${c.slug}`}
                className="inline-flex items-center gap-1.5 rounded-full border border-background-300/70 bg-background-50 px-3.5 py-1.5 text-xs font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700 whitespace-nowrap"
              >
                <i className={`${c.icon} text-primary-500`} />
                {c.name}
              </Link>
            ))}
          </div>
        </div>

        {/* 右：今日编辑力荐大卡 */}
        <div className="lg:col-span-5">
          {top && (
            <Link
              to={`/article/${top.slug}`}
              className="group relative block overflow-hidden rounded-2xl border border-background-200 bg-background-100"
            >
              <div className="aspect-[16/11] overflow-hidden">
                <img
                  src={top.cover}
                  alt={top.coverAlt}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-background-950/85 via-background-950/55 to-transparent p-5 pt-16 text-background-50 md:p-6 md:pt-20">
                <span className="inline-flex items-center gap-1.5 rounded-md bg-accent-500 px-2.5 py-1 text-xs font-semibold text-background-50">
                  <i className="ri-star-fill" />
                  今日编辑力荐 · Top1
                </span>
                <h2 className="mt-3 font-heading text-xl font-bold leading-snug md:text-2xl">
                  {top.title}
                </h2>
                <p className="mt-2 hidden text-sm leading-6 text-background-50/85 sm:block">
                  {top.excerpt}
                </p>
              </div>
            </Link>
          )}
        </div>
      </div>
    </section>
  );
}